/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMaskedTextInput = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M23 4v2H3v12h20v2H1V4zm-4 3v3.002l2.446-1.834 1.109 1.664-2.892 2.167 2.891 2.169-1.109 1.664L19 13.997V17h-2v-3.003l-2.445 1.835-1.11-1.664 2.891-2.169-2.89-2.167 1.108-1.664L17 10.002V7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMaskedTextInput as MaskedTextInput };
